// [ai] The two widget file endpoints (app/server/widgets.py): a custom widget's HTML, and a trusted module compiled on request.
import { jsonFetch, postJson, type Fetch } from "./http";
export type WidgetFile = { text: string; mtime: number };
export type Compiled = { ok: true; url: string };
const enc = encodeURIComponent;
export const widgetFile = (slug: string, src: string, fetchFn?: Fetch) => jsonFetch<WidgetFile>(`/api/views/${enc(slug)}/file/${enc(src)}`, {}, fetchFn);
export const compileModule = (slug: string, src: string, fetchFn?: Fetch) => postJson<Compiled>(`/api/views/${enc(slug)}/compile`, { src }, fetchFn);
